export enum TagType {
  // #region Spreng Connect Api
  SprengConnectApi_PingResult = "SprengConnectApi_PingResult",
  SprengConnectApi_SprengnetterIndexOverviewItemResponse = "SprengConnectApi_SprengnetterIndexOverviewItemResponse",
  SprengConnectApi_IndexChartDataResponse = "SprengConnectApi_IndexChartDataResponse",
  SprengConnectApi_InstitutionResponse = "SprengConnectApi_InstitutionResponse",
  SprengConnectApi_InstitutionPageByNameAndIdResponse = "SprengConnectApi_InstitutionPageByNameAndIdResponse",
  SprengConnectApi_RoleResponse = "SprengConnectApi_RoleResponse",
  SprengConnectApi_UserResponse = "SprengConnectApi_UserResponse",
  SprengConnectApi_IndexResponse = "SprengConnectApi_IndexResponse",
  SprengConnectApi_IndexLinkedDocumentResponse = "SprengConnectApi_IndexLinkedDocumentResponse",
  SprengConnectApi_FeatureAccessHistoryResponse = "SprengConnectApi_FeatureAccessHistoryResponse",
  SprengConnectApi_FeatureResponse = "SprengConnectApi_FeatureResponse",
  SprengConnectApi_BatchOutputResponse = "SprengConnectApi_BatchOutputResponse",
  SprengConnectApi_SubscriptionResponse = "SprengConnectApi_SubscriptionResponse",
  SprengConnectApi_InstitutionProfileSettingsResponse = "SprengConnectApi_InstitutionProfileSettingsResponse",
  SprengConnectApi_InstitutionUsersResponse = "SprengConnectApi_InstitutionUsersResponse",
  SprengConnectApi_UserProfileSettingsResponse = "SprengConnectApi_UserProfileSettingsResponse",
  SprengConnectApi_UserProfileResponse = "SprengConnectApi_UserProfileResponse",
  ValuationReport_RealEstateData = "ValuationReport_RealEstateData",
  ValuationPackage_Valuations = "ValuationPackage_Valuations",
  ValuationPackage_Images = "ValuationPackage_Images",
  ValuationPackage_Status = "ValuationPackage_Status",
  // #endregion Spreng Connect Api
}
